import { InputAdornment, TextField, TextFieldProps } from '@mui/material'
export type MolsonTextFieldProps = {
  dataTestId?: string
  iconStart?: JSX.Element | string
  iconEnd?: JSX.Element | string
} & TextFieldProps

const ENTER = 'Enter'

export const MolsonTextField = ({
  dataTestId,
  iconStart,
  iconEnd,
  ...props
}: MolsonTextFieldProps) => {
  return (
    <TextField
      data-testid={dataTestId}
      InputProps={{
        startAdornment: iconStart && (
          <InputAdornment position="start">{iconStart}</InputAdornment>
        ),
        endAdornment: iconEnd && (
          <InputAdornment position="end">{iconEnd}</InputAdornment>
        )
      }}
      onKeyDown={e => {
        if (e.key === ENTER) {
          const inputElement = e.target as HTMLInputElement
          inputElement.blur()
        }
      }}
      {...props}
    />
  )
}
